import React from 'react';
import { useFela } from 'react-fela';
import { sliderWidth } from './constants';

const rules = () => ({
  '&.volume-range-input': { // fix console global css
    cursor: 'pointer',
    opacity: '0',
    width: `${sliderWidth}px`,
  },
});

const VolumeRange = (props, ref) => {
  const { css } = useFela();

  return (
    <input className={`${css(rules)} volume-range-input`} ref={ref} {...props} />
  );
};

export default React.memo(React.forwardRef(VolumeRange));
